// CN marketplace configurations related to YourOrder scope.
import { i18n } from '@/local/index';
const { t } = i18n.global;
import yourOrderPageAwsRumConfig from '@/configs/awsRumConfig/views/yourOrderPage.js';
const { clickEvents, loadingEvents } = yourOrderPageAwsRumConfig;

// orderList tab
export const ORDER_LIST_TAB = [
  {
    name: t('modules.yourOrder.ORDER_LIST_STATUS.ALL'),
    status: 'ALL',
    recordLoadingEvents: loadingEvents.filterAllOrders.eventName
  },
  {
    name: t('modules.yourOrder.ORDER_LIST_STATUS.NOSHIPMENT'),
    status: 'ORDER_STATUS_NOSHIPMENT',
    recordClickEvent: clickEvents.filterToBeShippedOrdersButton.buttonName,
    recordLoadingEvents: loadingEvents.filterToBeShippedOrders.eventName
  },
  {
    name: t('modules.yourOrder.ORDER_LIST_STATUS.DELIVERYING'),
    status: 'ORDER_STATUS_DELIVERYING',
    recordClickEvent: clickEvents.filterToBeDeliveredOrdersButton.buttonName,
    recordLoadingEvents: loadingEvents.filterToBeDeliveredOrders.eventName
  },
  {
    name: t('modules.yourOrder.ORDER_LIST_STATUS.GOCOMMENT'),
    status: 'GOCOMMENT',
    recordClickEvent: clickEvents.filterToBeReviewedOrdersButton.buttonName,
    recordLoadingEvents: loadingEvents.filterToBeReviewedOrders.eventName
  },
  {
    name: t('modules.yourOrder.ORDER_LIST_STATUS.CANCEL'),
    status: 'ORDER_STATUS_CANCEL',
    recordClickEvent: clickEvents.filterCancelledOrdersButton.buttonName,
    recordLoadingEvents: loadingEvents.filterCancelledOrders.eventName
  }
];
